<template>
  <div class="flex flex-col items-center justify-center">
    <svg
      width="220"
      height="220"
      viewBox="0 0 124 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.4336 91C76.7341 91 96.4336 71.3005 96.4336 47C96.4336 22.6995 76.7341 3 52.4336 3C28.1331 3 8.43359 22.6995 8.43359 47C8.43359 71.3005 28.1331 91 52.4336 91Z"
        fill="url(#paint0_linear_18034_20890)"
      />
      <g filter="url(#filter0_d_18034_20890)">
        <rect
          x="30.0664"
          y="15.6719"
          width="45.6636"
          height="56.8439"
          rx="16"
          fill="url(#paint1_linear_18034_20890)"
        />
      </g>
      <rect
        x="34.1016"
        y="23.0059"
        width="50"
        height="1"
        rx="0.5"
        fill="black"
      />
      <rect
        x="34.1016"
        y="42.0059"
        width="36.6667"
        height="1"
        rx="0.5"
        fill="#D5D5D5"
      />
      <rect
        x="34.1016"
        y="61.0059"
        width="36.6667"
        height="1"
        rx="0.5"
        fill="#D5D5D5"
      />
      <rect
        x="34.1016"
        y="80.0059"
        width="36.6667"
        height="1"
        rx="0.5"
        fill="#D5D5D5"
      />
      <rect
        x="34.1016"
        y="99.0059"
        width="36.6667"
        height="1"
        rx="0.5"
        fill="#D5D5D5"
      />
      <g filter="url(#filter1_d_18034_20890)">
        <path
          d="M103.087 9.38867H81.0579C80.0314 9.38867 79.1992 10.2645 79.1992 11.3448V22.2418C79.1992 23.3221 80.0314 24.1979 81.0579 24.1979H103.087C104.114 24.1979 104.946 23.3221 104.946 22.2418V11.3448C104.946 10.2645 104.114 9.38867 103.087 9.38867Z"
          fill="white"
        />
      </g>
      <path
        d="M84.7 19.1344C85.915 19.1344 86.9 18.1494 86.9 16.9344C86.9 15.7193 85.915 14.7344 84.7 14.7344C83.485 14.7344 82.5 15.7193 82.5 16.9344C82.5 18.1494 83.485 19.1344 84.7 19.1344Z"
        fill="#CCC6D9"
      />
      <rect
        x="89.832"
        y="14.7344"
        width="11.7333"
        height="4.4"
        rx="2.2"
        fill="#D5D5D5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.3034 75.0716C70.026 75.0716 74.4149 73.6431 78.0617 71.1946L92.9849 85.4402L98.397 79.161L83.9967 65.4145C86.6563 61.6718 88.22 57.096 88.22 52.1549C88.22 39.4984 77.9599 29.2383 65.3034 29.2383C52.6469 29.2383 42.3867 39.4984 42.3867 52.1549C42.3867 64.8115 52.6469 75.0716 65.3034 75.0716ZM84.8512 52.1553C84.8512 62.8704 76.1648 71.5568 65.4497 71.5568C54.7345 71.5568 46.0482 62.8704 46.0482 52.1553C46.0482 41.4401 54.7345 32.7538 65.4497 32.7538C76.1648 32.7538 84.8512 41.4401 84.8512 52.1553Z"
        fill="#CCC6D9"
      />
      <g filter="url(#filter2_b_18034_20890)">
        <path
          d="M65.4482 71.934C76.4847 71.934 85.4315 63.0692 85.4315 52.134C85.4315 41.1987 76.4847 32.334 65.4482 32.334C54.4117 32.334 45.4648 41.1987 45.4648 52.134C45.4648 63.0692 54.4117 71.934 65.4482 71.934Z"
          fill="white"
          fill-opacity="0.3"
        />
      </g>
      <path
        d="M68.9029 52.1335L73.7388 47.3162C74.1919 46.8397 74.4401 46.2063 74.4307 45.5507C74.4214 44.8951 74.1552 44.269 73.6888 43.8054C73.2223 43.3418 72.5923 43.0772 71.9327 43.0679C71.2731 43.0587 70.6359 43.3054 70.1564 43.7557L65.3097 48.5729L60.4737 43.7557C60.241 43.5109 59.9613 43.315 59.6511 43.1795C59.3409 43.0441 59.0065 42.9718 58.6677 42.967C58.3289 42.9623 57.9926 43.0251 57.6786 43.1518C57.3647 43.2784 57.0795 43.4664 56.8399 43.7045C56.6003 43.9426 56.4112 44.2261 56.2837 44.5381C56.1563 44.8502 56.0931 45.1844 56.0979 45.5212C56.1027 45.8579 56.1754 46.1903 56.3117 46.4986C56.448 46.8069 56.6451 47.0849 56.8914 47.3162L61.7354 52.1335L56.8914 56.9507C56.6451 57.182 56.448 57.46 56.3117 57.7683C56.1754 58.0767 56.1027 58.409 56.0979 58.7457C56.0931 59.0825 56.1563 59.4167 56.2837 59.7288C56.4112 60.0408 56.6003 60.3243 56.8399 60.5624C57.0795 60.8005 57.3647 60.9885 57.6786 61.1152C57.9926 61.2418 58.3289 61.3046 58.6677 61.2999C59.0065 61.2951 59.3409 61.2229 59.6511 61.0874C59.9613 60.9519 60.241 60.756 60.4737 60.5113L65.3205 55.694L70.1672 60.5113C70.6513 60.935 71.2796 61.1593 71.9243 61.1386C72.569 61.1178 73.1814 60.8535 73.6368 60.3995C74.0922 59.9455 74.3563 59.336 74.3753 58.6952C74.3942 58.0544 74.1666 57.4305 73.7388 56.9507L68.9029 52.1335Z"
        fill="black"
      />
      <path
        d="M92.9844 85.4414L98.3965 79.1622L99.2116 79.9403C100.003 80.6953 100.476 81.7501 100.528 82.8725C100.58 83.9949 100.206 85.0931 99.4888 85.9255C98.7714 86.7579 97.7692 87.2562 96.7026 87.3109C95.636 87.3656 94.5925 86.9722 93.8016 86.2172L92.9864 85.439L92.9844 85.4414Z"
        fill="#E1DCEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.082 25.796C18.0751 25.2732 18.0095 24.7458 17.8783 24.2148C17.4182 22.3514 15.3657 21.155 13.1811 20.8738C10.9973 20.5925 8.72641 21.2326 7.85119 22.8535C7.35056 23.7802 7.28152 24.579 7.48608 25.2524C7.68978 25.9223 8.1731 26.4776 8.82909 26.9103C10.6581 28.1156 13.8612 28.3617 15.3225 27.8578C15.9984 27.6243 16.6586 27.3431 17.3017 27.0212C16.934 29.128 15.5642 31.124 13.736 32.9225C9.76301 36.8315 3.59762 39.7983 0.240006 40.8892C0.05961 40.9478 -0.0405226 41.1479 0.0155814 41.3363C0.0716855 41.5247 0.263299 41.6302 0.443695 41.5716C3.86777 40.4592 10.1532 37.4292 14.2047 33.4427C16.2979 31.3836 17.7894 29.0658 18.044 26.629C22.7757 23.9885 26.6616 19.1979 29.9838 15.1663C30.1072 15.0176 30.0908 14.7913 29.9476 14.6624C29.8043 14.5343 29.5885 14.5506 29.465 14.7002C26.2783 18.5668 22.5798 23.1663 18.082 25.796ZM17.3941 26.1792C17.42 25.5914 17.3647 24.9946 17.2154 24.3924C16.8175 22.7796 14.9885 21.8258 13.0973 21.5824C11.9381 21.4336 10.7462 21.5562 9.81137 21.9926C9.22357 22.2666 8.73933 22.6642 8.44759 23.2051C8.06435 23.9146 7.98148 24.5213 8.13858 25.0361C8.29567 25.5544 8.68585 25.9709 9.19424 26.3054C10.861 27.4043 13.7775 27.6378 15.1076 27.179C15.8922 26.9085 16.6535 26.5713 17.3941 26.1792Z"
        fill="black"
      />
      <circle cx="101.934" cy="59.8328" r="2.2" fill="#E3E3E3" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.8417 75.0103C19.2343 74.863 19.6474 74.6673 19.966 74.3841C20.3444 74.0476 20.4983 73.6142 20.6017 73.158C20.7344 72.572 20.7874 71.9477 20.9483 71.3606C21.0078 71.1427 21.1225 71.0603 21.1716 71.0237C21.296 70.9313 21.4217 70.9066 21.5399 70.9159C21.68 70.9266 21.8725 70.9824 21.9991 71.2296C22.0171 71.2649 22.0406 71.3189 22.0564 71.3927C22.0679 71.4468 22.0753 71.6162 22.0875 71.686C22.118 71.8579 22.1435 72.0298 22.1674 72.2027C22.247 72.7781 22.2929 73.2668 22.5444 73.7954C22.8858 74.513 23.2279 74.9521 23.6918 75.1466C24.1404 75.3346 24.6768 75.2992 25.362 75.1518C25.4272 75.1352 25.4918 75.1209 25.5556 75.1093C25.8578 75.0537 26.1466 75.2624 26.2059 75.5792C26.2653 75.8958 26.0732 76.2042 25.7738 76.2738C25.7113 76.2883 25.6497 76.3021 25.5888 76.3146C24.6628 76.5559 23.5907 77.417 22.9677 78.1709C22.7757 78.4034 22.4946 79.0533 22.2078 79.4679C21.9961 79.7738 21.7583 79.9754 21.5586 80.0466C21.4248 80.0946 21.312 80.0873 21.2188 80.063C21.0834 80.0279 20.9711 79.9507 20.8849 79.8279C20.8379 79.7607 20.7944 79.6707 20.7736 79.5558C20.7637 79.5005 20.7626 79.3599 20.7628 79.2963C20.7043 79.0847 20.6328 78.8781 20.5807 78.6646C20.4564 78.1552 20.2124 77.8328 19.9227 77.4067C19.6517 77.008 19.3607 76.7575 18.934 76.5576C18.8785 76.5433 18.4306 76.4279 18.2724 76.3617C18.0413 76.2645 17.9312 76.1019 17.8913 76.0142C17.8234 75.8656 17.8164 75.7357 17.8299 75.6274C17.85 75.4676 17.9181 75.3308 18.0391 75.2204C18.114 75.1518 18.2259 75.085 18.3757 75.0525C18.4915 75.0271 18.7986 75.0124 18.8417 75.0103ZM21.4693 74.1801C21.49 74.2287 21.5121 74.2777 21.5356 74.3271C22.0356 75.3781 22.5948 75.9649 23.2744 76.2496L23.2972 76.2588C22.8425 76.6141 22.4309 77.0111 22.1164 77.3918C21.9869 77.5485 21.8154 77.8741 21.6301 78.208C21.4618 77.6321 21.1865 77.2251 20.8404 76.7157C20.576 76.327 20.2989 76.0344 19.9584 75.796C20.2226 75.6533 20.4746 75.4861 20.6942 75.2909C21.0597 74.9658 21.3014 74.5892 21.4693 74.1801Z"
        fill="#CCC6D9"
      />
      <defs>
        <filter
          id="filter0_d_18034_20890"
          x="0.0664062"
          y="5.67188"
          width="105.664"
          height="116.844"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18034_20890"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18034_20890"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_18034_20890"
          x="72.1992"
          y="0.388672"
          width="51.7461"
          height="40.8086"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6" dy="4" />
          <feGaussianBlur stdDeviation="6.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18034_20890"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18034_20890"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_b_18034_20890"
          x="37.4648"
          y="24.334"
          width="55.9648"
          height="55.5996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="4" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_18034_20890"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_18034_20890"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18034_20890"
          x1="52.0944"
          y1="-11.3275"
          x2="52.9958"
          y2="143.194"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F2F2F2" />
          <stop offset="1" stop-color="#EFEFEF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18034_20890"
          x1="52.8982"
          y1="15.6719"
          x2="52.8982"
          y2="72.5158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.71875" stop-color="#FAFAFA" />
        </linearGradient>
      </defs>
    </svg>
    <p
      class="text-center text-lg font-medium"
      style="font-family: Poppins, Roboto, sans-serif;"
    >
      {{ $t(description) || $t("common.no_results") }}
    </p>
  </div>
</template>
<script>
export default {
  name: "no-result",
  props: {
    description: {
      type: String,
      default: ""
    }
  }
};
</script>
